<div class="snack-alert" [ngClass]="data?.styleClasses">
	<mat-icon [svgIcon]="data?.icon"> </mat-icon>
	<span class="op-ml-10" [ngClass]="data?.spanClasses">{{ data?.message }}</span>
</div>
